import React from 'react'
import { NSConfirm } from '../shared/ns-confirm'

/* Thin adapter kept for backwards-compatible call sites. The actual dialog is the
   shared design-system NSConfirm, so every confirmation across the app is identical.
   The legacy `icon`/`iconColor`/`iconBgColor` props are accepted but ignored — tone
   drives the colour + icon now. Pass `tone`, `nsIcon`, `requireText`, `bullets` or
   `detail` to use the richer NSConfirm features. */
const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false, // accepted for compat; NSConfirm shows its own busy spinner
  title = 'Confirm Action',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'destructive',
  tone,
  nsIcon,
  requireText,
  bullets,
  detail,
  // eslint-disable-next-line no-unused-vars
  icon, iconColor, iconBgColor, // legacy props — intentionally ignored
}) => {
  if (!isOpen) return null

  const resolvedTone = tone || (confirmVariant === 'destructive' ? 'danger' : 'accent')

  return (
    <NSConfirm
      tone={resolvedTone}
      icon={nsIcon}
      title={title}
      message={message}
      detail={detail}
      bullets={bullets}
      requireText={requireText}
      confirmLabel={confirmText}
      cancelLabel={cancelText}
      onConfirm={onConfirm}
      onCancel={onClose}
    />
  )
}

export default ConfirmationModal
